import { ReactNode, useMemo } from 'react';
import { ControllerType } from '../../types/ControllerType';
import { HookFormContext } from '../../context/HookFormContext';
import { ReadonlyIndicatorContext } from '../../context/ReadonlyIndicatorContext';

export interface IHookFormProviderProps {
    children: ReactNode;
    controller: ControllerType;
    /**
     * Признак «только для чтения» у полей формы (замок, подсказка). false — режим просмотра карточки, где только
     * чтение у всех полей; не задано — как у внешней формы (по умолчанию признак есть).
     */
    readonlyIndicators?: boolean;
}

const HookFormProvider = ({ children, controller, readonlyIndicators }: IHookFormProviderProps) => {
    // Значение контекста — одно на controller: новый объект на каждый рендер хозяина формы (карточка документа)
    // перерисовывал бы все поля формы (useHookFormController).
    const value = useMemo(() => ({ controller }), [controller]);
    const form = <HookFormContext value={value}>{children}</HookFormContext>;
    return readonlyIndicators === undefined ? (
        form
    ) : (
        <ReadonlyIndicatorContext value={readonlyIndicators}>{form}</ReadonlyIndicatorContext>
    );
};

export default HookFormProvider;
